<template>
  <div class="products-individuals-wrapper">
    <IndividualsHeader :el="'ag'" />
    <div class="text-group">
      <h3 class="text-ag">{{ $t('products-ag-1') }}</h3>
      <p>{{ $t('products-ag-2') }}</p>
      <p>{{ $t('products-ag-3') }}</p>
    </div>
    <Gallery :gallery="gallery" />
    <div class="content-row">
      <Dropdown
        :id="'agDropdownOne'"
        :color="color"
        :title="$t('products-ag-dd1-1')"
        :content="dropdownOne"
        :open="true"
      />
    </div>
    <div class="content-row" id="alloysElement">
      <Dropdown
        :id="'agDropdownTwo'"
        :color="color"
        :title="$t('products-ag-dd2-1')"
        :content="dropdownTwo"
        :open="true"
      />
    </div>
    <div class="content-row">
      <Dropdown
        :id="'agDropdownThree'"
        :color="color"
        :title="$t('products-ag-dd3-1')"
        :content="dropdownThree"
        :open="true"
      />
    </div>
    <div class="content-row">
      <Files :color="color" :files="files" />
    </div>
    <InterestingFacts :title="$t('products-ag-if-title')" :facts="facts" :color="color" />
  </div>
</template>

<script>
import IndividualsHeader from "./shared/IndividualsHeader";
import InterestingFacts from "./shared/InterestingFacts";
import Dropdown from "./shared/Dropdown";
import Gallery from "./shared/Gallery";
import Files from "./shared/Files";

export default {
  components: {
    IndividualsHeader,
    InterestingFacts,
    Dropdown,
    Gallery,
    Files
  },
  props: ["color"],
  data() {
    return {
      gallery: [
        {
          type: "image",
          url: require("../../../assets/img/products/ag/ag_gallery_1.jpg")
        },
        {
          type: "image",
          url: require("../../../assets/img/products/ag/ag_gallery_2.jpg")
        },
        {
          type: "image",
          url: require("../../../assets/img/products/ag/ag_gallery_3.jpg")
        },
        {
          type: "image",
          url: require("../../../assets/img/products/ag/ag_gallery_4.jpg")
        },
        {
          type: "image",
          url: require("../../../assets/img/products/ag/ag_gallery_5.jpg")
        }
      ],
      files: {
        bg: [
          "Брошура КЦМ Сребро.pdf",
          "Сребро-Информационен лист за безопасност.pdf"
        ],
        en: [
          "Brochure KCM Silver.pdf",
          "Silver SDS.pdf",
          "Silver nitrate SDS.pdf"
        ]
      }
    };
  },
  computed: {
    dropdownOne() {
      return {
        table: [
          [this.$t("brand"), "Ag 99.99 min.", "Ag 99.96 min."],
          [this.$t("elements"), "%", "%"],
          [{ el: "Cu" }, "0.01 max.", "0.04"],
          [{ el: "Fe" }, "0.001 max.", "0.004"],
          [{ el: "Pb" }, "0.001 max.", "0.01"],
          [{ el: "Bi" }, "0.00005 max.", "0.002"],
          [{ el: "Te" }, "0.00005 max.", "0.005"],
          [{ el: "Pd" }, "0.001 max.", "-"],
          [{ el: "Pt" }, "0.0004 max.", "-"],
          [{ el: "Au" }, "0.0005 max.", "-"],
          [this.$t("products-dd-11"), "0.01 max.", "0.04 max."]
        ],
        columns: {
          left: [
            {
              img: require("../../../assets/img/products/ag/dd1.jpg")
            }
          ],
          right: [
            {
              title: this.$t("products-ag-dd1-2"),
              texts: [
                this.$t("products-ag-dd1-3"),
                this.$t("products-ag-dd1-4"),
                this.$t("products-ag-dd1-5"),
                this.$t("products-ag-dd1-6"),
                this.$t("products-ag-dd1-7")
              ]
            }
          ]
        }
      };
    },
    dropdownTwo() {
      return {
        table: [
          [
            {
              text: `${this.$t("products-ag-dd2-2")}, ${this.$t(
                "products-ag-dd2-3"
              )}`,
              colspan: 6
            }
          ],
          [
            this.$t("brand"),
            "Ag 99.995 min.",
            "Ag 99.996 min.",
            "Ag 99.997 min.",
            "Ag 99.998 min.",
            "Ag 99.999 min."
          ],
          [this.$t("elements"), "%", "%", "%", "%", "%"],
          [{ el: "Cu" }, "0.0025", "0.0020", "0.0020", "0.0015", "0.0010"],
          [{ el: "Fe" }, "0.0025", "0.0020", "0.0020", "0.0015", "0.0010"],
          [{ el: "Pb" }, "0.0025", "0.0020", "0.0020", "0.0015", "0.0010"],
          [{ el: "Bi" }, "0.0005", "0.0002", "0.0002", "0.0001", "0.0001"],
          [{ el: "Te" }, "0.0005", "0.0002", "0.0002", "0.0001", "0.0001"],
          [{ el: "Zn" }, "0.0005", "0.0002", "0.0002", "0.0001", "0.0001"],
          [{ el: "Cd" }, "0.0002", "0.0001", "0.0001", "0.0001", "0.0001"],
          [{ el: "Sd" }, "0.0005", "0.0005", "0.0005", "0.0002", "0.0002"],
          [{ el: "Sn" }, "0.0005", "0.0002", "0.0002", "0.0001", "0.0001"],
          [{ el: "Ni" }, "0.0002", "0.0002", "0.0002", "0.0001", "0.0001"],
          [{ el: "Pd" }, "0.0005", "0.0002", "0.0002", "0.0002", "0.0002"],
          [{ el: "Pt" }, "0.0005", "0.0005", "0.0005", "0.0002", "0.0002"],
          [{ el: "Au" }, "0.0005", "0.0005", "0.0005", "0.0002", "0.0002"],
          [{ el: "Co" }, "0.0005", "0.0002", "0.0002", "0.0001", "0.0001"],
          [{ el: "Se" }, "0.0005", "0.0005", "0.0005", "0.0020", "0.0002"],
          [{ el: "As" }, "0.0005", "0.0002", "0.0002", "0.0100", "0.0001"],
          [
            this.$t("products-dd-11"),
            "0.005",
            "0.004",
            "0.003",
            "0.002",
            "0.001"
          ]
        ],
        columns: {
          titles: [
            this.$t("products-ag-dd2-4"),
            this.$t("products-ag-dd2-5"),
            this.$t("products-ag-dd2-6")
          ],
          left: [
            {
              img: require("../../../assets/img/products/ag/dd2.jpg")
            }
          ],
          right: [
            {
              spec: {
                title: this.$t("products-dd-12"),
                mass: "30 +/- 2 kg",
                left: this.$t("products-dd-13"),
                right: this.$t("products-dd-14"),
                l0: this.$t("products-ag-dd2-7"),
                w0: this.$t("products-ag-dd2-8"),
                l: this.$t("products-ag-dd2-9"),
                w: this.$t("products-ag-dd2-10"),
                h: this.$t("products-ag-dd2-11")
              }
            },
            {
              title: this.$t("products-ag-dd2-12"),
              texts: [this.$t("products-ag-dd2-13")]
            }
          ]
        }
      };
    },
    dropdownThree() {
      return {
        table: [
          [
            this.$t("products-dd-17"),
            this.$t("products-dd-18"),
            this.$t("products-dd-19"),
            this.$t("products-dd-20"),
            this.$t("products-dd-21")
          ],
          [
            this.$t("products-ag-dd3-2"),
            "Silver nitrate,min",
            "AgNO<sub>3</sub>",
            "99,5",
            "99,8"
          ],
          [
            this.$t("products-ag-dd3-3"),
            "Silver, min",
            "AgNO<sub>3</sub>",
            "99,5",
            "99,8"
          ],
          [
            this.$t("products-ag-dd3-4"),
            "Iron,max",
            "AgNO<sub>3</sub>",
            "99,5",
            "99,8"
          ],
          [
            this.$t("products-ag-dd3-5"),
            "Copper, lead sulphate, chloride Substances not precipitated by hydrochloric acid",
            "Cu, Pb , SO<sub>4</sub>, Cl",
            "",
            ""
          ]
        ],
        columns: {
          left: [
            {
              img: require("../../../assets/img/products/ag/dd3.jpg")
            }
          ],
          right: [
            {
              title: this.$t("products-ag-dd3-6"),
              texts: [
                this.$t("products-ag-dd3-7"),
                this.$t("products-ag-dd3-8")
              ]
            },
            {
              title: this.$t("products-ag-use1"),
              texts: [
                this.$t("products-ag-use2"),
                this.$t("products-ag-use3"),
                this.$t("products-ag-use4"),
                this.$t("products-ag-use5"),
                this.$t("products-ag-use6"),
                this.$t("products-ag-use7"),
                this.$t("products-ag-use8")
              ]
            },
            {
              title: this.$t("products-ag-use9"),
              texts: [
                this.$t("products-ag-use10"),
                this.$t("products-ag-use11"),
                this.$t("products-ag-use12"),
                this.$t("products-ag-use13")
              ]
            }
          ]
        }
      };
    },
    facts() {
      return [
        {
          img: require("../../../assets/img/products/ag/if_1.png"),
          text: this.$t("products-ag-if-1")
        },
        {
          img: require("../../../assets/img/products/ag/if_2.png"),
          text: this.$t("products-ag-if-2")
        },
        {
          img: require("../../../assets/img/products/ag/if_3.png"),
          text: this.$t("products-ag-if-3")
        },
        {
          img: require("../../../assets/img/products/ag/if_4.png"),
          text: this.$t("products-ag-if-4")
        },
        {
          img: require("../../../assets/img/products/ag/if_5.png"),
          text: this.$t("products-ag-if-5")
        },
        {
          img: require("../../../assets/img/products/ag/if_6.png"),
          text: this.$t("products-ag-if-6")
        },
        {
          img: require("../../../assets/img/products/ag/if_7.png"),
          text: this.$t("products-ag-if-7")
        },
        {
          img: require("../../../assets/img/products/ag/if_8.png"),
          text: this.$t("products-ag-if-8")
        },
        {
          img: require("../../../assets/img/products/ag/if_9.png"),
          text: this.$t("products-ag-if-9")
        },
        {
          img: require("../../../assets/img/products/ag/if_10.png"),
          text: this.$t("products-ag-if-10")
        },
        {
          img: require("../../../assets/img/products/ag/if_11.png"),
          text: this.$t("products-ag-if-11")
        },
        {
          img: require("../../../assets/img/products/ag/if_12.png"),
          text: this.$t("products-ag-if-12")
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.products-individuals-wrapper {
  padding-bottom: 50px;
  .text-group {
    margin: 0 auto;
    padding-top: 40px;
    padding-right: $sidesPadding + $chemicalLarge + ($sidesPadding / 2);
    padding-left: $sidesPadding + $chemicalLarge + ($sidesPadding / 2);
  }
  .content-row {
    padding-right: $sidesPadding + $chemicalLarge + ($sidesPadding / 2);
    padding-left: $sidesPadding + $chemicalLarge + ($sidesPadding / 2);
  }
}
@media screen and (max-width: 1600px) {
  .products-individuals-wrapper {
    .text-group {
      padding-right: $sidesPadding1600 + $chemicalLarge +
        ($sidesPadding1600 / 2);
      padding-left: $sidesPadding1600 + $chemicalLarge + ($sidesPadding1600 / 2);
    }
    .content-row {
      padding-right: $sidesPadding1600 + $chemicalLarge +
        ($sidesPadding1600 / 2);
      padding-left: $sidesPadding1600 + $chemicalLarge + ($sidesPadding1600 / 2);
    }
  }
}
@media screen and (max-width: 1440px) {
  .products-individuals-wrapper {
    .text-group {
      padding-right: $sidesPadding1600 + $chemicalLarge1440 +
        ($sidesPadding1600 / 2);
      padding-left: $sidesPadding1600 + $chemicalLarge1440 +
        ($sidesPadding1600 / 2);
    }
    .content-row {
      padding-right: $sidesPadding1600 + $chemicalLarge1440 +
        ($sidesPadding1600 / 2);
      padding-left: $sidesPadding1600 + $chemicalLarge1440 +
        ($sidesPadding1600 / 2);
    }
  }
}
@media screen and (max-width: 1280px) {
  .products-individuals-wrapper {
    .text-group {
      padding-right: $sidesPadding1280 + $chemicalLarge1440 +
        ($sidesPadding1280 / 2);
      padding-left: $sidesPadding1280 + $chemicalLarge1440 +
        ($sidesPadding1280 / 2);
    }
    .content-row {
      padding-right: $sidesPadding1280 + $chemicalLarge1440 +
        ($sidesPadding1280 / 2);
      padding-left: $sidesPadding1280 + $chemicalLarge1440 +
        ($sidesPadding1280 / 2);
    }
  }
}
@media screen and (max-width: 1000px) {
  .products-individuals-wrapper {
    .text-group {
      padding-right: $sidesPadding1280;
      padding-left: $sidesPadding1280;
    }
    .content-row {
      padding-right: $sidesPadding1280;
      padding-left: $sidesPadding1280;
    }
  }
}
@media screen and (max-width: 600px) {
  .products-individuals-wrapper {
    .text-group {
      padding-right: $sidesPadding600;
      padding-left: $sidesPadding600;
    }
    .content-row {
      padding-right: $sidesPadding600;
      padding-left: $sidesPadding600;
    }
  }
}
</style>

